import React from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import { IHandlers } from './types';
import { IToastDialogProps } from 'shared-types';
import { Button, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const NS = 'ToastDialog';

export default function ToastDialog({
  msg,
  type,
  isImportant,
  hideDismissBtn,
  handleClose,
  customButton1Text,
  handleCustomButton1,
  customButton2Text,
  handleCustomButton2,
  customButton3Text,
  handleCustomButton3,
}: IToastDialogProps & IHandlers) {
  return (
    <div>
      <Snackbar
        open={!!msg}
        anchorOrigin={{
          vertical: isImportant ? 'top' : 'bottom',
          horizontal: isImportant ? 'center' : 'right',
        }}
      >
        <Alert
          severity={type}
          variant="filled"
          action={
            !hideDismissBtn && (
              <Button color="inherit" size="small" onClick={() => handleClose()}>
                OK
              </Button>
            )
          }
        >
          <span dangerouslySetInnerHTML={{ __html: msg }} />
          {customButton1Text && (
            <div className={style.customBtnWrap}>
              {customButton1Text && handleCustomButton1 && (
                <Button color="inherit" size="small" onClick={() => handleCustomButton1()}>
                  {customButton1Text}
                </Button>
              )}
              {customButton2Text && handleCustomButton2 && (
                <Button color="inherit" size="small" onClick={() => handleCustomButton2()}>
                  {customButton2Text}
                </Button>
              )}
              {customButton3Text && handleCustomButton3 && (
                <Button color="inherit" size="small" onClick={() => handleCustomButton3()}>
                  {customButton3Text}
                </Button>
              )}
            </div>
          )}
        </Alert>
      </Snackbar>
    </div>
  );
}
